export default "__VITE_ASSET__DzpCAVWO__"